export default __webpack_public_path__ + "static/media/close.805476cb.svg";